// extracted by mini-css-extract-plugin
export var container = "Card-module--container--16ad5";
export var header = "Card-module--header--8ac25";
export var simpleContent = "Card-module--simpleContent--83abe";